import Api from "../../lib/api";
import { setMessage } from "../shared/notification/slice";

export const postOrder = async (orderEntity) =>
    Api.post("orders", {
        ...orderEntity,
    });

export const getBranchLocation = async (branchId) => {
    try {
        const response = await Api.get(`branches/${branchId}/location`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get branch location`,
            isError: true,
        });
    }
};
